import { render, staticRenderFns } from "./galleryIntroduction.vue?vue&type=template&id=6f2ffc97&"
import script from "./galleryIntroduction.vue?vue&type=script&lang=js&"
export * from "./galleryIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./galleryIntroduction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports